import { useRef } from "react";

export const useOTPInput = (otpValue: string, onOTPChange: (value: string) => void) => {
    const inputRefs = useRef<(HTMLInputElement | null)[]>([]);

    const handlePaste = (e: React.ClipboardEvent<HTMLInputElement>) => {
        e.preventDefault();
        const pasteData = e.clipboardData.getData("Text").slice(0, 5);
        if (/^\d{5}$/.test(pasteData)) {
            onOTPChange(pasteData);
            pasteData.split("").forEach((char, index) => {
                if (inputRefs.current[index]) inputRefs.current[index]!.value = char;
            });
        }
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;
        if (value.length <= 5 && /^\d*$/.test(value)) {
            onOTPChange(value);
        }
    };

    return {
        inputRefs,
        handlePaste,
        handleInputChange,
    };
};
